module.exports = "/assets/best_for_britain_logo-d5b72ee0e2d6f59dd236af1958b61583.png";